import { Component, Input } from '@angular/core';

/**
 * Generated class for the TableHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'table-header',
  templateUrl: 'table-header.html',
})
export class TableHeaderComponent {
  @Input()
  ths: Array<{
    text: string;
    flex: number;
  }>;

  constructor() {
    console.log('Hello TableHeaderComponent Component');
  }
}



// WEBPACK FOOTER //
// ./src/components/table-header/table-header.ts